// extracted by mini-css-extract-plugin
module.exports = {"action-control":"action-control--DHJal","info":"info--PmUNR","action-btn":"action-btn--PJNe9","form":"form---p8YI"};